import { createActionNameBuilder } from '../create-action-name-builder';
import { ActionType } from '../enums';

/**
 * Хелпер для формирования имён событий вида `event/general/init-app/processing`
 */
export const eventNameBuilder = createActionNameBuilder(ActionType.EVENT);
